import { IonCard, IonCardContent } from '@ionic/react'
import './Description.css'

interface Props {
    content: string
}

const Description: React.FC<Props> = (props) => {
    return (
        <IonCard className="description">
            <IonCardContent>
                <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
            </IonCardContent>
        </IonCard>
    )
}

export default Description